import {useFormik} from 'formik'
import {cancelDemandeDemontage} from '../../../../components/requests'
import {ModeleDemandeDemontage} from '../../../../components/Models'
import React, {useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {Button} from 'react-bootstrap'
import {useAuth} from '../../../modules/auth'

const DemandeDemontageAnnulationForm = (props) => {
  const {showModalProp, demandeDemontageId, setData, data} = props
  const [loading, setLoading] = useState(false)

  const initialValues: ModeleDemandeDemontage = {
    id: demandeDemontageId,
    commentaireAnnulation: '',
  }

  const onSubmitHandler = (values) => {
    setLoading(true)
    cancelDemandeDemontage(demandeDemontageId, values)
      .then((response) => {
        setLoading(false)
        if (response?.status === 200 && response?.data !== undefined) {
          showModalProp(false)

          // Mise à jour temporaire des données du tableau
          const updatedData = data.map((item) =>
            item?.id === demandeDemontageId ? {...item, statut: {...item.statut,
                code: 'ANNULE',
                id: 7,
                libelle: 'Annulée'
              }} : item
          )
          setData(updatedData)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const formik = useFormik<ModeleDemandeDemontage>({
    initialValues: initialValues,
    onSubmit: onSubmitHandler,
    validateOnBlur: true,
    validateOnChange: true,
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className='modal-body pt-3'>
          <div className='row'>
            <div className='col-sm-12'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Commentaire</label>
              <TextInput
                fieldName={'commentaireAnnulation'}
                inputType={'text'}
                inputClassName={'form-control form-control-lg mb-3 mb-lg-0'}
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className='modal-footer d-flex gap-4 justify-content-end'>
          <Button className='btn btn-primary' type='submit' disabled={loading}>
            {loading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Annulation en cours...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Confirmer'
            )}
          </Button>

          <Button variant='secondary' onClick={() => showModalProp(false)} disabled={loading}>
            Annuler
          </Button>
        </div>
      </form>
    </div>
  )
}

export {DemandeDemontageAnnulationForm}
